export const TRANSLATION_DOMAIN = 'account:team.list';

export const PERMISSIONS_LEARN_MORE_LINK = '/articles/115011734788-User-Permissions';
